import { api_GET } from "../api/_axios.js";

const setup_api =
{
    get: function () {
        const promise = new Promise((resolve, reject) => {
            api_GET(`setup`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
}

export default setup_api
